export default class Address {
    name: string;
    geo?: Geolocation;
    city: string;
    country: string;
    zipCode: string;
    state?: string;
    addressLine1: string;
    addressLine2?: string;
};